export enum EKeyOption {
  POLICY = 'POLICY',
  FAQ = 'FAQ',
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
  INTRODUCTION = 'INTRODUCTION',
  OWNERSHIP = 'OWNERSHIP',
  CONTACT = 'CONTACT',
  HOME = 'HOME',
  SPECIALDEALNOTE = 'SPECIALDEALNOTE',
  OLDSPECIALDEAL = 'OLDSPECIALDEAL',
  NEWSPECIALDEAL = 'NEWSPECIALDEAL',
  EVENT = 'EVENT',
  EVENTBANNER = 'EVENTBANNER',
  EVENTCONTENT = 'EVENTCONTENT',
  EVENTACTIONS = 'EVENTACTIONS',
}
export type TPostOption = {
  [x: string]: any
  title: string
  key: EKeyOption
  value: any
}

export type TQueryOption = {
  'key[]': EKeyOption[]
}
export type TPatchOption = Partial<TPostOption>
